var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7958 13.8293L20.7875 12.8376L18.1667 10.2168L14.0583 14.3251C13.7042 14.1126 13.2792 14.0418 12.8542 14.0418C11.5083 14.0418 10.375 15.1751 10.375 16.521C10.375 17.8668 11.5083 19.0001 12.8542 19.0001C14.2 19.0001 15.3333 17.8668 15.3333 16.521C15.3333 16.096 15.1917 15.671 15.05 15.3168L16.3958 13.971L18.025 15.6001L19.0167 14.6085L17.3875 12.9793L18.1667 12.2001L19.7958 13.8293ZM12.8542 17.5835C12.2875 17.5835 11.7917 17.0876 11.7917 16.521C11.7917 15.9543 12.2875 15.4585 12.8542 15.4585C13.4208 15.4585 13.9167 15.9543 13.9167 16.521C13.9167 17.0876 13.4208 17.5835 12.8542 17.5835Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41667 15.4583C5.41667 12.6958 7.6125 10.5 10.375 10.5C11.7917 10.5 13.1375 11.1375 14.1292 12.2L15.1917 11.2792C14.5542 10.5708 13.8458 10.0042 12.9958 9.65C13.9875 8.87083 14.625 7.59583 14.625 6.25C14.625 3.9125 12.7125 2 10.375 2C8.0375 2 6.125 3.9125 6.125 6.25C6.125 7.59583 6.7625 8.87083 7.825 9.65C5.55833 10.6417 4 12.8375 4 15.4583V19H9.66667V17.5833H5.41667V15.4583ZM7.54167 6.25C7.54167 4.69167 8.81667 3.41667 10.375 3.41667C11.9333 3.41667 13.2083 4.69167 13.2083 6.25C13.2083 7.80833 11.9333 9.08333 10.375 9.08333C8.81667 9.08333 7.54167 7.80833 7.54167 6.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/admin.b939185ea53c83789b0b2a5361a375ca.svg";
export { ForwardRef as ReactComponent };